import { useRef, useState } from "react";
import { uploadFile, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";

export function PhotoUpload({ value, onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Seleziona un'immagine");
      return;
    }
    setBusy(true);
    try {
      const res = await uploadFile(file);
      onChange(res.path);
    } catch {
      toast.error("Caricamento foto fallito");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="h-20 w-20 rounded-md border border-border bg-secondary/50 overflow-hidden flex items-center justify-center shrink-0">
        {value ? (
          <img src={fileUrl(value)} alt="Foto bene" className="h-full w-full object-cover" />
        ) : (
          <ImagePlus className="h-7 w-7 text-muted-foreground/40" />
        )}
      </div>
      <div className="flex gap-2">
        <input ref={inputRef} type="file" accept="image/*" onChange={pick} className="hidden" data-testid="photo-input" />
        <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => inputRef.current?.click()} data-testid="photo-upload-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4 mr-1.5" />}
          {value ? "Cambia foto" : "Carica foto"}
        </Button>
        {value && (
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange("")} data-testid="photo-remove-button">
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}

export function FileUploadField({ value, filename, onChange, accept = "application/pdf", label = "Carica PDF" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadFile(file);
      onChange(res.path, res.filename);
    } catch {
      toast.error("Caricamento file fallito");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <input ref={inputRef} type="file" accept={accept} onChange={pick} className="hidden" data-testid="file-input" />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => inputRef.current?.click()} data-testid="file-upload-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4 mr-1.5" />}
        {value ? "Sostituisci" : label}
      </Button>
      {value && (
        <span className="text-xs text-muted-foreground flex items-center gap-1">
          {filename || "file.pdf"}
          <button type="button" onClick={() => onChange("", "")} className="ml-1"><X className="h-3.5 w-3.5" /></button>
        </span>
      )}
    </div>
  );
}
